"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Parser_1 = require("../Parser");

var parserSupport_1 = require("../parserSupport");

var ValidationResult_1 = require("../ValidationResult");

var DateParser_1 = require("./DateParser");

var StringOrDateParser =
/*#__PURE__*/
function (_Parser_1$Parser) {
  _inherits(StringOrDateParser, _Parser_1$Parser);

  function StringOrDateParser() {
    var _this;

    _classCallCheck(this, StringOrDateParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StringOrDateParser).apply(this, arguments));
    _this.dateParser = new DateParser_1.DateParser(DateParser_1.DateParser.ISO_PATTERN);
    _this.stringParser = new Parser_1.StringParser();
    return _this;
  }

  _createClass(StringOrDateParser, [{
    key: "parse",
    value: function parse(input, level) {
      var stringRes = this.stringParser.parse(input, level);
      var dateRes = this.dateParser.parse(input, level);

      if (stringRes instanceof ValidationResult_1.ValidationError && dateRes instanceof ValidationResult_1.ValidationError) {
        return stringRes;
      }

      if (dateRes instanceof ValidationResult_1.ValidationSuccess) {
        return dateRes;
      }

      if (stringRes instanceof ValidationResult_1.ValidationSuccess) {
        return stringRes;
      }

      return parserSupport_1.badType(input, 'string');
    }
  }]);

  return StringOrDateParser;
}(Parser_1.Parser);

exports.StringOrDateParser = StringOrDateParser;